import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import RunModelForm, { RunModelFormValues } from "@features/run/RunModelForm"
import { GraphDto, UserGraphDto } from "@custom-types/graphs"

const FORM_ID = "run-model-form"

interface IRunModelDialogProps {
  open: boolean
  graph: UserGraphDto | GraphDto | undefined
  onClose: () => void
  onSubmit: (values: RunModelFormValues) => void
}

export default function RunModelDialog({ open, graph, onClose, onSubmit }: IRunModelDialogProps) {
  const handleClose = () => onClose()
  if (!graph) return

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Run Model</DialogTitle>
      <DialogContent sx={{ minWidth: 500 }}>
        <RunModelForm id={FORM_ID} graph={graph} onSubmit={onSubmit} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Cancel
        </Button>
        <Button color="error" variant="contained" type="submit" form={FORM_ID}>
          Run
        </Button>
      </DialogActions>
    </Dialog>
  )
}
